import {config} from '../config';

export default ({
    defaultApiUrl: config.api(),
    newApiUrls: {
        v2: config.apiV2(),
    },
    overrides: {
        // [resourceRequests]: {
        //     [GET_LIST]: {
        //         forAll: true,
        //         apiUrlIdentifier: 'v2',
        //     },
        // },
    },
});

// Overrides example:
//     'resourceName': {
//         'GET_LIST': {
//             'forAll': true,
//             'apiUrlIdentifier': 'v2',
//         },
//         'FETCH': {
//             'forAll': false,
//             'endpoints': ['endpoint1', 'endpoint2'],
//             'apiUrlIdentifier': 'v2',
//         },
//     },